import React from 'react';
import BookingAgreement from './BookingAgreement';
import SubmitButton from '../../forms/SubmitButton';

const CaptainApproveContent = ({ hideModal, booking, insuranceType }) => (
  <div>
    <div>
      <BookingAgreement userType="captain" booking={booking} insuranceType={insuranceType} />
      <div className="Grid Grid--withGutter">
        <div className="Grid-cell u-size1of2 u-sm-sizeFull">
          <div className="Grid Grid--withGutter">
            <div className="Grid-cell u-size2of3 u-sm-sizeFull u-sm-mb1">
              <SubmitButton
                disabled={false}
                dataTestId="action-cta"
                additionalClasses="Button--aquamarine u-sizeFull u-sm-mb1"
              >
                Approve booking
              </SubmitButton>
            </div>
            <div className="Grid-cell u-size1of3 u-sm-sizeFull">
              <button
                onClick={hideModal}
                type="button"
                className="Button u-fsSm Button--darkAquamarineOutline u-sizeFull"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default CaptainApproveContent;
